<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BnPplZ/tc-custom/9781614486602.jpg?1702083390558" alt="This image is the cover for the book Too Sharp to Fail"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Too Sharp to Fail
      </h1>
      <p class="bookDescription body article font2">
        <b>“Specific examples of how to develop the skillset and mindset you need to . . . build the career that you genuinely want.” —Marshall Goldsmith, #1 <i>New York Times</i>–bestselling author of <i>Triggers</i></b><br/>  <br/> Meet Justin, a twenty-something college graduate. He’s probably a lot like you—young, driven, and determined to succeed. After landing a job in corporate America, Justin quickly learns the road to success is more complex than he thought, and his college education is simply not enough. Justin must become a student again.<br/>  <br/> But this time, the classroom is an office packed with negative coworkers and a disgruntled boss. With the guidance and support of a mentor and professional coach, Justin learns the keys to succeeding in any workplace. From a seasoned human resources professional, <i>Too Sharp to Fail</i> is packed with real-life experiences and life-changing lessons. After reading Justin’s story, you’ll never view your career in the same way.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kiana L. Wilson
      </h2>
      
      <p class="authorDescription body article">Kiana L. Wilson is an ICF Associate Certified Coach, Professional in Human Resources, and Global Career Development Facilitator with over ten years of experience in career and professional development. As the founder of A Sharper U, a career development firm in Tampa, Florida, Kiana has created and led several corporate training programs for high potential employees and organizational leaders. In addition to her professional work, Kiana is a volunteer career and leadership coach and serves on several professional boards and advisory committees. Learn more about Kiana and A Sharper U at www.ASharperU.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?00d10a41